/**
 * P4 (team feedback 2026-10-09, Pedro): PEP and US person read in ENGLISH on
 * every surface. The stored PEP values stay Portuguese (`PEPStatus` in
 * backend/app/models/person.py; the importer and the DB enum use them), so the
 * English label is applied at display time from this one map. Both fields
 * default to blank ("Not answered"); in the answer dropdowns "No" comes first.
 */

export const NOT_ANSWERED = 'Not answered';

/** Stored PEP value (or Agreements-list rollup key) → English label. */
const PEP_LABELS: Record<string, string> = {
  'Não': 'No',
  'PEP': 'PEP',
  'Membro de Família de PEP': 'Family member of a PEP',
  'Pessoa Próxima de PEP': 'Close associate of a PEP',
  // Agreements-list rollup keys (services/agreement_aggregates.py).
  'Nao': 'No',
  'Related': 'Related to PEP',
};

export function pepLabel(value: string | null | undefined): string {
  if (value == null || value === '') return NOT_ANSWERED;
  return PEP_LABELS[value] ?? value;
}

export function usPersonLabel(value: boolean | null | undefined): string {
  if (value === true) return 'Yes';
  if (value === false) return 'No';
  return NOT_ANSWERED;
}

/** PEP answer options: stored values, English labels, "No" first. */
export const PEP_OPTIONS = ['Não', 'PEP', 'Membro de Família de PEP', 'Pessoa Próxima de PEP']
  .map((value) => ({ value, label: pepLabel(value) }));

/** US-person answer options (the Person form holds 'Yes' / 'No'), "No" first. */
export const US_PERSON_OPTIONS = [
  { value: 'No', label: 'No' },
  { value: 'Yes', label: 'Yes' },
];

/** Reference pages linked next to a field and in the Help guide (Pedro 2026-10-13). The Help
 *  guide (HELP_RM.md §6a) carries the same links as Markdown — keep the two in step. */
export interface ReferenceLink { label: string; url: string }

export const IRS_US_PERSON_URL =
  'https://www.irs.gov/individuals/international-taxpayers/classification-of-taxpayers-for-us-tax-purposes';

export const US_PERSON_LINKS: ReferenceLink[] = [
  { label: 'IRS: classification of taxpayers for US tax purposes', url: IRS_US_PERSON_URL },
];

export const PEP_LINKS: ReferenceLink[] = [
  { label: 'Council of Europe (MONEYVAL): politically exposed persons',
    url: 'https://www.coe.int/en/web/moneyval/implementation/politically-exposed-persons' },
  { label: 'EU Official Journal C/2023/724 (Portuguese, PDF)',
    url: 'https://eur-lex.europa.eu/legal-content/PT/TXT/PDF/?uri=OJ:C_202300724' },
  { label: 'FATF guidance on politically exposed persons, Recommendations 12 and 22 (PDF)',
    url: 'https://www.fatf-gafi.org/content/dam/fatf-gafi/guidance/Guidance-PEP-Rec12-22.pdf.coredownload.pdf' },
  { label: 'OpenSanctions: PEP data', url: 'https://www.opensanctions.org/pep/' },
  { label: 'OpenSanctions: research', url: 'https://www.opensanctions.org/research/' },
];
